export const theme = {
  breakpoints: {
    sm: 'min-width: 576px',
    md: 'min-width: 768px',
    lg: 'min-width: 992px',
    xl: 'min-width: 1200px',
  },
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.25)',
  typography: {
    base: 1.4,
    scale: {
      xs: 1.125,
      sm: 1.125,
      md: 1.250,
      lg: 1.250,
    }
  },
  typeStyles: ( exp ) => {
    return `font-size: ${theme.typography.base * Math.pow( theme.typography.scale.xs, exp )}rem;
    @media ( ${theme.breakpoints.sm} ) {
      font-size: ${theme.typography.base * Math.pow( theme.typography.scale.sm, exp )}rem;
    }
    @media ( ${theme.breakpoints.md} ) {
      font-size: ${theme.typography.base * Math.pow( theme.typography.scale.md, exp )}rem;
    }
    @media ( ${theme.breakpoints.lg} ) {
      font-size: ${theme.typography.base * Math.pow( theme.typography.scale.lg, exp )}rem;
    }`
  },
};

export const defaultColours = {
  colours: {
    black: '#2e2e2e',
    white: 'white',
    grey: '#c4c4c4',
    greyDark: '#999999',
    greyMedium: '#f5f5f6',
    greyFaint: '#f7f8f9',
    highlight: '#03BBC4',
    highlight2: '#FE135E',
  },
};

export const atColours = {
  colours: {
    black: '#2e2e2e',
    white: 'white',
    grey: '#c4c4c4',
    greyDark: '#999999',
    greyMedium: '#f5f5f6',
    greyFaint: '#f7f8f9',
    highlight: '#FDD700',
    highlight2: '#FE135E',
  },
};

export const dwwColours = {
  colours: {
    black: '#2e2e2e',
    white: 'white',
    grey: '#c4c4c4',
    greyDark: '#999999',
    greyMedium: '#f5f5f6',
    greyFaint: '#f7f8f9',
    highlight: '#6E08FF',
    highlight2: '#FE135E',
  },
};
